import { render, staticRenderFns } from "./Login_forgetPassword.vue?vue&type=template&id=618038ef&scoped=true"
import script from "./Login_forgetPassword.vue?vue&type=script&lang=js"
export * from "./Login_forgetPassword.vue?vue&type=script&lang=js"
import style0 from "./Login_forgetPassword.vue?vue&type=style&index=0&id=618038ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618038ef",
  null
  
)

export default component.exports